import { Component, ViewChild, OnInit, AfterViewInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CmsService } from 'src/app/Services/cms.service';

@Component({
  selector: 'app-politica-privacidade',
  templateUrl: './politica-privacidade.component.html',
  standalone: false
})
export class PoliticaPrivacidadeComponent implements OnInit{
  // ---CMS---
  documentos_legais_content: string = 'linhas-documentos-legal';
  politicaPrivacidade: any = {};
  
  constructor(
      private cmsService: CmsService,
      private router: Router,
      private translate: TranslateService,
      private title: Title
  ) {
      this.translate.get('navLinks').pipe().subscribe(trans => {
        let pageTitle =  trans['linhas'] + ' | ' + trans['politicaPrivacidade']
        this.title.setTitle(pageTitle);
      })
    }

  ngOnInit(){
    this.getContent();
  }

  getContent(){
    this.cmsService.getContentList(this.documentos_legais_content, 'pt').subscribe(
      {
        next: data => {
          this.politicaPrivacidade = data['body']['data']['Politica_Privacidade'];
        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }

}
